import { render } from "./ClearfixPage.vue?vue&type=template&id=13b3c93f&ts=true"
import script from "./ClearfixPage.vue?vue&type=script&lang=ts"
export * from "./ClearfixPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__